import React, { Fragment } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getRoomInfo,
  getTouristsText,
} from '../../../../store/selectors/package';
import withMobile from '../../hocs/withMobile';

import styles from './roomInfoHeader.module.css';

const RoomInfoHeader = ({ room, touristsLabel, isMobile }) =>
  !isMobile && (
    <div className={styles.container}>
      <h2 className={cn(styles.text, styles.title)}>
        <span>{room.name_ru}</span>
        {room.area > 0 && (
          <>
            <span> · </span>
            <span>{`${room.area} м²`}</span>
          </>
        )}
      </h2>
      <span className={cn(styles.text, styles.content)}>
        <span>{touristsLabel}</span> · <span>{room.name_en}</span>
      </span>
    </div>
  );
RoomInfoHeader.propTypes = {
  room: PropTypes.shape({}).isRequired,
  touristsLabel: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

const mapPropsToState = (state) => ({
  room: getRoomInfo(state),
  touristsLabel: getTouristsText(state),
});

export default connect(mapPropsToState)(withMobile(RoomInfoHeader));
